
let markerColor
const selectors = document.querySelectorAll("input.accent-selector");


export default function map() {
  // api key
  // AIzaSyA26gHxyncm4bzkIIbZJPZWB119olvZ7wI
  const mapDom = document.getElementById("map");

  if (mapDom == null || mapDom == undefined) {
    return
  }

  function initMap() {

    const lat = mapDom.getAttribute('data-lat');
    const lng = mapDom.getAttribute('data-lng');

    let zoom = 17;
    const ion = { lat: Number(lat), lng: Number(lng) };


    const zoomIn = document.querySelector('.button-zoom-in')
    const zoomOut = document.querySelector('.button-zoom-out')

    const ionMarker = document.createElement('div');
    ionMarker.className = 'marker';
    ionMarker.textContent = 'Ion'

    const map = new google.maps.Map(mapDom, {
      center: ion,
      zoom: zoom,
      minZoom: 12,
      maxZoom: 20,
      mapId: '43b52d10bface75a',
      zoomControl: false,
      mapTypeControl: false,
      scaleControl: false,
      streetViewControl: false,
      rotateControl: false,
      fullscreenControl: false
    });

    let icon = {
      path: google.maps.SymbolPath.CIRCLE,
      scale: 10,
      fillOpacity: 1,
      strokeWeight: 1,
      fillColor: getComputedStyle(document.documentElement)
      .getPropertyValue('--color-accent')
    }

    let markerView = new google.maps.Marker({
      position: ion,
      map: map,
      icon
      // <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50"><circle cx="25" cy="25" r="25"/></svg>
    });

    // change icon color
    selectors.forEach((selector) => {

      selector.addEventListener("colorChange", (event) => {
        icon.fillColor = event.detail.color();
        markerView.setIcon(icon);
      });
    });

    zoomIn.addEventListener("click", () => {
      map.setZoom(map.zoom + 1);
    });

    zoomOut.addEventListener("click", () => {
      map.setZoom(map.zoom - 1);
    });
  }

  window.addEventListener("load", (event) => {
    initMap()
  });
}
